import React from 'react';
import './styles/Header.css';

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <p>© Erik Yamamoto - developed with React</p>
      </footer>
    );
  }
}

export default Footer;
